import { Callout, Select } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { type IntegrationStatus } from 'src/core/modules/bookkeep/integration/status';
import {
  type Journal,
  type JournalMapping,
} from 'src/core/modules/bookkeep/settings/accounting';

export const BankJournalSelectField = ({
  availableJournals,
  initialJournal,
  onCreate,
  accountingIntegration,
}: {
  availableJournals: Journal[];
  initialJournal: Journal | undefined;
  onCreate: (journalMapping: JournalMapping) => void;
  accountingIntegration: IntegrationStatus;
}) => {
  const { t } = useTranslation('global');

  const currentValue = initialJournal
    ? {
        key: initialJournal.id,
        label: `${initialJournal.externalCode} - ${initialJournal.externalName}`,
      }
    : undefined;

  const handleSelect = (selectedOption: { key: string; label: string }) => {
    const selectedJournal = availableJournals.find(
      (journal) => journal.id === selectedOption.key,
    );

    if (selectedJournal && selectedJournal !== initialJournal) {
      onCreate({
        mappingType: 'bank_journal',
        mappedJournal: selectedJournal,
      });
    }
  };

  return (
    <>
      <div className="mt-24">
        <h5 className="text-content-primary body-m mb-8">
          {t('bookkeep.integrations.settings.chift.bankJournalExport.title')}
        </h5>
        <p className="text-content-secondary-bg-primary body-m mb-8">
          {t(
            'bookkeep.integrations.settings.chift.bankJournalExport.description',
          )}
        </p>
      </div>

      {accountingIntegration.integration !== 'noIntegration' &&
        accountingIntegration.integration !== 'switchInProgress' &&
        accountingIntegration.settingsValidation.journalBank && (
          <Callout
            className="mt-16 mb-16"
            title={t(
              'bookkeep.integrations.settings.journalErrors.bankJournalsErrors',
            )}
            variant="alert"
          />
        )}

      <div className="bankJournalSelectorField w-6/12">
        <Select
          className={
            accountingIntegration.integration !== 'noIntegration' &&
            accountingIntegration.integration !== 'switchInProgress' &&
            accountingIntegration.settingsValidation.journalBank
              ? 'border-border-alert'
              : ''
          }
          fit="parent"
          value={currentValue}
          onSelect={handleSelect}
          options={availableJournals.map((journal) => ({
            key: journal.id,
            label: `${journal.externalCode} - ${journal.externalName}`,
          }))}
          placeholder={t(
            'bookkeep.integrations.settings.chift.bankJournalExport.selectJournal',
          )}
        />
      </div>
    </>
  );
};
